const Ajax = require('common/infra/ajax');

const buildUrl = function(params) {
    var _params = {
        type: params.type,
        limit: params.limit
    };
    if (params) {
        if (params.read) {
            _params.read = params.read;
        }
        if (params.resource) {
            _params.resource = params.resource;
        }
        if (params.latest) {
            _params.latest = params.latest;
        }
        if (params.oldest) {
            _params.oldest = params.oldest;
        }
    }

    const query = _.chain(_params)
        .map(function(v, k) {
            if (v) {
                return k + '=' + encodeURIComponent(v);
            }
        }).compact().join('&');

    return `/api/my/notifications?${query}`;
}

class API {
    getMyNotifications(options) {
        return Ajax.GET(buildUrl(options));
    }

    postRead(notificationIds) {
        return Ajax.PUT(`/api/my/notifications?read=true`, {nids: notificationIds});
    }

    postUnread(notificationIds) {
        return Ajax.PUT(`/api/my/notifications?read=false`, {nids: notificationIds});
    }

    getReviewCount() {
        return Ajax.GET(`/api/my/notifications/count?type=review`);
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./notify/infra/api/notify.js